export default __webpack_public_path__ + "static/media/forgotpass.8e319c4c.svg";